import React from "react";
import { useEffect, useState } from "react";
import baseURL from "./components/authComponents/baseURL/BaseURL";
import SucessStoryPage from "./components/homepage/blog-Screen/SuccessStoryPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HomePage from "./pages/HomePage";
import LoginScreen from "./components/authComponents/Login";
import SignUpScreen from "./components/authComponents/SignUp";
import StepperForm from "./components/authComponents/SignUpStepper";
import Profile from "./pages/Profile";
import ContactUs from "./components/homepage/contact-us/ContactUs";
import AboutUs from "./components/homepage/about-us/AboutUs";
import OtherProfiles from "./components/homepage/profile/OtherProfileView";
import Navbar from "./components/shared/Navbar";
import Footer from "./components/shared/Footer";
import AdminSettings from "./components/adminSideComponents/settings/index";
import AdminDashboard from "./components/adminSideComponents/dashboard/index";
import Users from "./components/adminSideComponents/users";
import NotFoundPage from "./components/errorPage/NotFound";
import TermConditions from "./pages/TermConditions";
import ForgotPasswordScreen from "./components/authComponents/ForgotPassword";
import ResetPasswordScreen from "./components/authComponents/ResetPassword";
import AllProfiles from "./components/homepage/all-profiles/AllProfiles";
import LoginViaOTP from "./components/authComponents/LoginViaOTP";
import OTPsetter from "./components/authComponents/OTPsetter";
import loginToken from "./components/authComponents/localStorageItems/LoginTokin";
import AllCountries from "./components/adminSideComponents/countries";
import AllStates from "./components/adminSideComponents/states";
import AllCities from "./components/adminSideComponents/cities";
import EditAnnouncementForm from "./components/adminSideComponents/Announcement/edit_announcement";
import LoginPopUp from "./components/authComponents/LoginPopUp";
import BlogsIndex from "./components/adminSideComponents/blogs/blogsIndex";
import EditInformationForm from "./components/authComponents/EditInformationForm";
import UpdatePassword from "./components/authComponents/UpdatePassword";
import BlogPage from "./pages/BlogPage";
import { FirstBlog } from "./components/homepage/blog-Screen/FirstBlog";
import { SecondBlog } from "./components/homepage/blog-Screen/SecondBlog";
import { ThirdBlog } from "./components/homepage/blog-Screen/ThirdBlog";
import FourthBlog from "./components/homepage/blog-Screen/FourthBlog";
import Emails from "./components/adminSideComponents/emails/Emails";
import WhatsAppIcon from "./components/reusableComponents/WhatsappComponent";
import ReferralsTable from "./components/adminSideComponents/refferals/Refferals";
import Referrals from "./components/adminSideComponents/refferals/Refferals";
import RefundPolicy from "./components/homepage/refundPolicy/RefundPolicy";
import EditPricing from "./components/adminSideComponents/pricing/EditPricing";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState("");
  const [userStatus, setUserStatus] = useState("");
  const [canRequestReview, setCanRequestReview] = useState(false);
  const [userId, setUserID] = useState(false);
  const [showLoginPopUp, setLoginPopUp] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("Scroll to top")
  });
  useEffect(() => {
    const getRole = async () => {
      try {
        const response = await baseURL.get("/profile", {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        });
        setUserRole(response.data.data.role);
        setUserStatus(response.data.data.status)
        setCanRequestReview(response.data.data.can_request_review)
        setUserID(response.data.data.id)
      } catch (error) {
        console.error(error);
      }
    };

    if (loginToken) {
      getRole();
    }
  }, []);
  useEffect(() => {
    if (
      loginToken &&
      (location.pathname === "/login" ||
        location.pathname === "/signup" ||
        location.pathname === "/otpsender" ||
        location.pathname === "/setotp")
    ) {
      navigate("/");
    }
  }, [location.pathname, navigate]);
  const hideNavbarFooterPaths = [
    "/login",
    "/signup",
    "/create-account",
    "/admin/dashboard",
    "/admin/users",
    "/admin/refferals",
    "/admin/emails",
    "/admin/settings",
    "/admin/countries",
    "/admin/states",
    "/admin/blogs",
    "/admin/cities",
    "/edit-profile",
    "/admin/edit-announcement",
    "/admin/edit-pricing",
  ];
  const hideNavbarFooter = hideNavbarFooterPaths.includes(location.pathname);
  
  // Hide WhatsApp icon on admin pages
  const hideWhatsAppPaths = [
    "/admin/dashboard",
    "/admin/users",
    "/admin/refferals",
    "/admin/emails",
    "/admin/settings",
    "/admin/countries",
    "/admin/states",
    "/admin/cities",
    "/admin/edit-announcement",
    "/admin/edit-pricing",
  ];
  const showWhatsApp = !hideWhatsAppPaths.includes(location.pathname);
  
  return (
    <>
      {!hideNavbarFooter && (
        <Navbar userRole={userRole} userStatus={userStatus} canRequestReview={canRequestReview} userId={userId} setLoginPopUp={setLoginPopUp} />
      )}
      {showLoginPopUp && <LoginPopUp onClose={() => setLoginPopUp(false)} />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/login"
          element={loginToken ? <Navigate to="/" replace /> : <LoginScreen />}
        />
        <Route
          path="/otpsender"
          element={loginToken ? <Navigate to="/" replace /> : <LoginViaOTP />}
        />
        <Route
          path="/setotp"
          element={loginToken ? <Navigate to="/" replace /> : <OTPsetter />}
        />
        <Route
          path="/signup"
          element={loginToken ? <Navigate to="/" replace /> : <SignUpScreen />}
        />
        <Route
          path="/profile"
          element={
            loginToken ? (
              <Profile setLoginPopUp={setLoginPopUp} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/profile-details/:id"
          element={
            loginToken ? <OtherProfiles /> : <Navigate to="/login?action=profile-click" replace />
          }
        />
        <Route path="/blogs">
          <Route index element={<BlogPage />} />
          <Route path="success-story" element={<SucessStoryPage />} />
          <Route path="first-blog" element={<FirstBlog />} />
          <Route path="second-blog" element={<SecondBlog />} />
          <Route path="third-blog" element={<ThirdBlog />} />
          <Route path="fourth-blog" element={<FourthBlog />} />
        </Route>
        <Route path="/updatepassword" element={<UpdatePassword />} />

        <Route path="/edit-profile" element={<EditInformationForm />} />
        <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
        <Route path="/reset-password" element={<ResetPasswordScreen />} />
        <Route path="/create-account" element={<StepperForm />} />
        <Route path="/termAndConditions" element={<TermConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/all-profiles" element={<AllProfiles />} />
        <Route path="/contact" element={<ContactUs />} />
        {/* <Route path="/support" element={<Support />} /> */}
        <Route path="/about" element={<AboutUs />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/edit-pricing" element={<EditPricing />} />
        <Route path="/admin/users" element={<Users />} />
        <Route path="/admin/emails" element={<Emails />} />
        <Route path="/admin/refferals" element={<Referrals />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/countries" element={<AllCountries />} />
        <Route path="/admin/states" element={<AllStates />} />
        <Route path="/admin/blogs" element={<BlogsIndex />} />
        <Route path="/admin/cities" element={<AllCities />} />
        <Route path="/admin/edit-announcement" element={<EditAnnouncementForm />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ToastContainer />
      {!hideNavbarFooter && <Footer />}
      
      {/* WhatsApp Icon Component */}
      {showWhatsApp && <WhatsAppIcon phoneNumber="+923295239629" message="Hello! I am interested in registering my profile on Select Proposal" />}
    </>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
